export const API_ENDPOINTS = {
  "login":"login",
  "listOfConferences": "listOfConferences",
  "conferenceInfo":"conferenceInfo",
  "listOfAttendees":"listOfAttendees",
  "listOfProfiles":"listOfProfiles",
  "profileDetails":"profileDetails",
  "attendeesInfo":"attendeesInfo",
  "listOfObjectives":"listOfObjectives",
  "actions": "actions",
  "viewFollowup": "viewFollowup",
  "attendees":"attendees",
  "listOfFollowups":"listOfFollowups",
  "saveFollowup":"saveFollowup",
  "attendeeFilter":"attendeeFilter",
  "typeFilter":"typeFilter",
  "updatePeople":"updatePeople",
  "updateArcutisUser":"updateArcutisUser",
  "updateHcpProfile":"updateHcpProfile",
  "addMeetingInputs":"addMeetingInputs",
  "updateMeeting":"updateMeeting",
  "updateAttendees":"updateAttendees",
  "createGroupChat":"createGroupChat",
  "reports":"reports",
  "traceMail":"traceMail",
  "getTemplateAddMeetingsBulk":"getTemplateAddMeetingsBulk",
  "addMeetingsBulk":"addMeetingsBulk",
  "addConference":"addConference",
  "getStagingDetails":"getStagingDetails",
  "updateStagingDetails":"updateStagingDetails",
  "getConference":"getConference",
  "getEvents":"getEvents",
  "domainCheck":"domainCheck",
  "ssoLogin":"ssoLogin",
  "logout":"logout",
  "listOfSurveys":"listOfSurveys",
  "surveyTemplate":"surveyTemplate",
  "surveyKOLs":"surveyKOLs",
  "surveyConferences":"surveyConferences",
  "surveyMeetings":"surveyMeetings",
  "submitSurveyResponse":"submitSurveyResponse",
  "submittedResponses":"submittedResponses",
  "surveyFilters":"surveyFilters",
  "usersList":"usersList",
  "userOps":"userOps",
  "userData":"userData",
  "rolesList":"rolesList",
  "kolEdit":"kolEdit",
  "kolSections":"kolSections",
  "kolProfile":"kolProfile",
  "kols":"kols",
  "products":"products",
  "prescription":"prescription",
  "portfolios":"portfolios",
  "summary":"summary",
  "hcpGroupChat":"hcpGroupChat",
  "intTabs":'intTabs',
  "advScore":"advScore",
  "tllScorecard":"tllScorecard",
  "podiumStatements":"podiumStatements",
  "updateCards":"updateCards",
  "surveys":"surveys",
  "listOfTimezones":"listOfTimezones",
  "meetingFilters":"meetingFilters",
  "followupRequired":"followupRequired",
  "editAdvScore":"editAdvScore",
  "followups":"followups",
  "tllScorePodium": "tllScorePodium",
  "tllAddEdit":"tllAddEdit",
  "addConfMtg":"addConfMtg",
  "favouriteKols":"favouriteKols",
  "auditLogs":"auditLogs",
  "lookup":"lookup",
  "surveyArcAttendees":"surveyArcAttendees",
  "roleOps":"roleOps",
  "roleData":"roleData",
  "tllDetailed": "tllDetailed",
  "permissionsList":"permissionsList",
  "embedReport":"embedReport",
  "listWorkspaces":"listWorkspaces",
  "listDepartments":"listDepartments",
  "listSubDepartments":"listSubDepartments",
  "listReports":"listReports",
  "saveReports":"saveReports",
  "reportsTable":"reportsTable",
  "getReportDetails":"getReportDetails",
  "deptSubdept":"deptSubdept",
  "permissionOps":"permissionOps",
  "permissionData":"permissionData",
  "exportReport":"exportReport"
};

export const API_ENVIRONMENT = {
  "company-info": "local",
  // 'userLogin': 'dev',
};

//update this for each deployment
export const Version = '2.0.11';
